import './bootstrap';
import '../css/app.css';

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import { createI18n } from 'vue-i18n';
import WebsiteLayout from './Layouts/Website.vue';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: async (name) => {
        const page = await resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue'));
        page.default.layout = page.default.layout || WebsiteLayout;
        return page;
    },
    setup({ el, App, props, plugin }) {
        const i18n = createI18n({
            legacy: false,
            globalInjection: true,
            warnHtmlMessage: false,
            locale: props.initialPage.props.locale,
            messages: {
                [props.initialPage.props.locale]: props.initialPage.props.translations
            }
        });

        const app = createApp({ render: () => h(App, props) });

        app.use(plugin)
           .use(ZiggyVue)
           .use(i18n);

        app.config.globalProperties.$trans = (key) => i18n.global.t(key);

        return app.mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});

